/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetTemporalClosures200ResponseInner
 */
export interface GetTemporalClosures200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetTemporalClosures200ResponseInner
     */
    product: string;
    /**
     * 
     * @type {string}
     * @memberof GetTemporalClosures200ResponseInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetTemporalClosures200ResponseInner
     */
    brandId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTemporalClosures200ResponseInner
     */
    integrationId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTemporalClosures200ResponseInner
     */
    locationId: string;
    /**
     * 
     * @type {string}
     * @memberof GetTemporalClosures200ResponseInner
     */
    comments?: string;
    /**
     * 
     * @type {Date}
     * @memberof GetTemporalClosures200ResponseInner
     */
    end: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetTemporalClosures200ResponseInner
     */
    errorTime?: Date;
    /**
     * 
     * @type {number}
     * @memberof GetTemporalClosures200ResponseInner
     */
    attempt: number;
    /**
     * 
     * @type {Date}
     * @memberof GetTemporalClosures200ResponseInner
     */
    endExecuted?: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetTemporalClosures200ResponseInner
     */
    start: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetTemporalClosures200ResponseInner
     */
    startExecuted?: Date;
}

/**
 * Check if a given object implements the GetTemporalClosures200ResponseInner interface.
 */
export function instanceOfGetTemporalClosures200ResponseInner(value: object): value is GetTemporalClosures200ResponseInner {
    if (!('product' in value) || value['product'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('end' in value) || value['end'] === undefined) return false;
    if (!('attempt' in value) || value['attempt'] === undefined) return false;
    if (!('start' in value) || value['start'] === undefined) return false;
    return true;
}

export function GetTemporalClosures200ResponseInnerFromJSON(json: any): GetTemporalClosures200ResponseInner {
    return GetTemporalClosures200ResponseInnerFromJSONTyped(json, false);
}

export function GetTemporalClosures200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTemporalClosures200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'product': json['product'],
        'id': json['id'],
        'brandId': json['brandId'] == null ? undefined : json['brandId'],
        'integrationId': json['integrationId'] == null ? undefined : json['integrationId'],
        'locationId': json['locationId'],
        'comments': json['comments'] == null ? undefined : json['comments'],
        'end': (new Date(json['end'])),
        'errorTime': json['errorTime'] == null ? undefined : (new Date(json['errorTime'])),
        'attempt': json['attempt'],
        'endExecuted': json['endExecuted'] == null ? undefined : (new Date(json['endExecuted'])),
        'start': (new Date(json['start'])),
        'startExecuted': json['startExecuted'] == null ? undefined : (new Date(json['startExecuted'])),
    };
}

export function GetTemporalClosures200ResponseInnerToJSON(json: any): GetTemporalClosures200ResponseInner {
    return GetTemporalClosures200ResponseInnerToJSONTyped(json, false);
}

export function GetTemporalClosures200ResponseInnerToJSONTyped(value?: GetTemporalClosures200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'product': value['product'],
        'id': value['id'],
        'brandId': value['brandId'],
        'integrationId': value['integrationId'],
        'locationId': value['locationId'],
        'comments': value['comments'],
        'end': ((value['end']).toISOString()),
        'errorTime': value['errorTime'] == null ? undefined : ((value['errorTime']).toISOString()),
        'attempt': value['attempt'],
        'endExecuted': value['endExecuted'] == null ? undefined : ((value['endExecuted']).toISOString()),
        'start': ((value['start']).toISOString()),
        'startExecuted': value['startExecuted'] == null ? undefined : ((value['startExecuted']).toISOString()),
    };
}

